import React from "react";
import { useState } from "react";
import TableLoader from "shared/TableLoader";
import { CardHeader, Col, Input, Label, Row, Spinner } from "reactstrap";
import CustomTextField from "components/CustomTextField";
import { Button } from "react-bootstrap";
import KycDetailEdit from "./KycDetailEdit";
import Select from "react-select";
import SaathiCertificationEdit from "./AddNewSaathi/SaathiCertificationEdit";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import { selectCurrentRoles, selectCurrentToken, selectCurrentUser } from "features/auth/authSlice";
import { API_URL } from "app/config";
import { useForm } from "react-hook-form";

const SaathiCertificationDetails = ({
  SaathiUserData,
  SaathiDetailsRefetch,
}) => {
  const {id} = useParams();
  const user_token = useSelector(selectCurrentToken);
  const currentUser = useSelector(selectCurrentUser);
  const RolesFromToken = useSelector(selectCurrentRoles);
  const { handleSubmit, reset } = useForm();

  const [loader, setLoader] = useState(false);
  const [CertificateData, setCertificateData] = useState();
  const [isEdit, setisEdit] = useState(false);
  const [BankingselectedFile, setBankingSelectedFile] = useState();
  const [pospselectedFile, setpospSelectedFile] = useState([]);
  const POSPchangeHandler = (event) => {
    setpospSelectedFile(event.target.files[0]);
  };

  const [InsuranceExamStatus, setInsuranceExamStatus] = useState("");
  function handelInsuranceExamStatus(InsuranceExamStatus) {
    setInsuranceExamStatus(InsuranceExamStatus);
  }

  const [BankingExamStatus, setBankingExamStatus] = useState("");
  function handelBankingExamStatus(BankingExamStatus) {
    setBankingExamStatus(BankingExamStatus);
  }
  
  const BankingchangeHandler = (event) => {
    setBankingSelectedFile(event.target.files[0]);
  };
  const [PoliceselectedFile, setPoliceSelectedFile] = useState('')
  const PolicechangeHandler = event => {
    setPoliceSelectedFile(event.target.files[0])

  }

  const ExamStatusData = [
    {
      label: "Exam Status",
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
  ];


  const onSubmitSaathiData = (e) => {
    setLoader(true);
    const formData = new FormData();
    formData.append(
      "is_insurance_exam_passed",
      InsuranceExamStatus === "" ?  SaathiUserData.certification_details?.is_insurance_exam_passed : InsuranceExamStatus
    );
    formData.append(
      "is_banking_exam_passed",
      BankingExamStatus === "" ? SaathiUserData?.certification_details?.is_banking_exam_passed :  BankingExamStatus
    );
    formData.append("posp_certificate", pospselectedFile);
    formData.append("bank_certificate", BankingselectedFile);
    formData.append("police_verification_certificate", PoliceselectedFile)
    formData.append("created_by", currentUser.sub);
    formData.append("created_by_name", currentUser.name);
    formData.append("applicant_id", id);

    fetch(`${API_URL}/empanelment/api/certification-details/`, {
      method: "POST",
      body: formData,
      headers: { Authorization: `Token ${user_token}` },
    }).then((resp) => {
      const result = resp;
      if (result.status === 200 || result.status === 201) {
        resp
          .json()
          .then((response) => {
            swal("Success", {
              buttons: false,
              icon: "success",
              title: response.message,
              timer: 1500,
            });
            setLoader(false);
            setisEdit(false);
            SaathiDetailsRefetch(id);
          })
          .catch((err) => console.log(err));
      } else {
        result
          .json()
          .then((response) => {
            swal("...Ooops", {
              buttons: false,
              icon: "warning",
              title: response.message,
              timer: 1500,
            });
            setLoader(false);
          })
          .catch((err) => console.log(err));
      }
    });
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 48,
    }),
  };

  return (
    <Row style={{ marginTop: "-1%" }}>
      <>
        <CardHeader
          style={{ padding: "13px" }}
          className=" mb-3 d-flex justify-content-between align-items-center"
        >
          <h5 className="m-0">Certification Details </h5>

          { RolesFromToken.groups?.includes("Maker") ?   SaathiUserData?.onboarding_status === "QC1 Approved" ? "" : <div>  {isEdit ? (
            <Button
              size="sm"
              id="editDetails"
              type=""
              className=" btn-danger waves-effect  "
              onClick={() => setisEdit(false)}
            >
              Cancel <i className="mdi mdi-window-close"></i>
            </Button>
          ) : (
            <Button
              size="sm"
              id="editDetails"
              type=""
              className="  waves-effect  "
              onClick={() => setisEdit(true)}
            >
              Edit <i className="mdi mdi-file-edit-outline"></i>
            </Button>
          )}
          </div> : ""}
        </CardHeader>
        <Row>
          <form onSubmit={handleSubmit(onSubmitSaathiData)}>
           <Row> {isEdit == true ? (
              

              <Col lg="3" className="mb-3">
                <Label
                  className="f_p text_c f_400"
                  name="is_insurance_exam_passed"
                >
                  Insurance Exam Passed
                </Label>
                <Select
                  value={
                    InsuranceExamStatus?.label
                  }
                  placeholder={
                    SaathiUserData?.certification_details
                      ?.is_insurance_exam_passed === true
                      ? "Yes"
                      : "No" || "Select..."
                  }
                  onChange={(InsuranceExamStatus) => {
                    handelInsuranceExamStatus(InsuranceExamStatus.value);
                  }}
                  options={ExamStatusData}
                  styles={customStyles}
                />
              </Col>
            ) : (
              <Col lg="3" className="mb-2">
                <Label>Is insurance exam passed</Label>
                <CustomTextField
                  name=""
                  value={
                    SaathiUserData?.certification_details?.is_insurance_exam_passed === true ? "Yes" : "No" || "Select .."
                  }
                  disabled
                  placeholder="Select"
                />
              </Col>
            )}
            {isEdit === true ? (
              <Col lg="3" className="mb-3">
                <Label
                  className="f_p text_c f_400"
                  name="is_banking_exam_passed"
                >
                  Bank Exam Passed
                </Label>
                <Select
                  value={
                    BankingExamStatus?.label
                  }
                  onChange={(BankingExamStatus) => {
                    handelBankingExamStatus(BankingExamStatus.value);
                  }}
                  options={ExamStatusData}
                  styles={customStyles}
                  placeholder={
                    SaathiUserData?.certification_details
                      ?.is_banking_exam_passed === true
                      ? "Yes"
                      : "No" || "Select ..."
                  }
                />
              </Col>
            ) : (
              <Col lg="3" className="mb-2">
                <Label>Is banking exam passed</Label>
                <CustomTextField
                  name=""
                  value={SaathiUserData?.certification_details?.is_banking_exam_passed === true ? "Yes"  :  "No"   }
                  disabled
                />
              </Col>
            )}
           {isEdit === true ?   <Col lg="5" className="mb-3">
                <Label className="f_p text_c f_400">
                  Upload Police Verification Certificate{" "}

                  <small>(Image Or Pdf Format Only*)</small>
                </Label>
                <input
                  type="file"
                  className="form-control"
                  id="policecertificate"
                  name="police_verification_certificate"
                  onChange={PolicechangeHandler}
                  accept="image/*,.pdf"
                  required
                />
              </Col>  : "" }
            </Row>
           
            <Row>
              {InsuranceExamStatus == true && isEdit === true   || SaathiUserData?.certification_details?.is_insurance_exam_passed === true  ? (
                <Col lg="4" className={`mb-3 ${RolesFromToken.groups?.includes("Maker") ? "" :"d-none"}`} >
                  <Label className="f_p text_c f_400">
                    Upload POSP Certificate{" "}
                    <small>(Image Or Pdf Format Only*)</small>
                  </Label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*,.pdf"
                    name="posp_certificate"
                    onChange={POSPchangeHandler}
                  />
                </Col>
              ) : null}
              {BankingExamStatus == true && isEdit === true  || SaathiUserData?.certification_details?.is_banking_exam_passed === true   ? (
                <Col lg="4" className={`mb-3 ${RolesFromToken.groups?.includes("Maker") ? "" :"d-none"}`}>
                  <Label className="f_p text_c f_400">
                    Upload Banking Certificate{" "}
                    <small>(Image Or Pdf Format Only*)</small>
                  </Label>
                  <input
                    type="file"
                    className="form-control"
                    name="bank_certificate"
                    accept="image/*,.pdf"
                    onChange={BankingchangeHandler}
                  />
                </Col>
              ) : null}
            </Row>
            {isEdit === true ? (
              <Col lg={12} className={`text-center m-auto  mb-3`}>
                <button
                  type="submit"
                  className="btn btn-success text-white p-3 ms-3"
                >
                  <span class="mdi mdi-content-save "></span> Update
                  Certification Details &nbsp;
                  {loader ? (
                    <Spinner animation="border" size="sm"></Spinner>
                  ) : (
                    ""
                  )}
                </button>
              </Col>
            ) : (
              ""
            )}
          </form>
        </Row>
      </>
    </Row>
  );
};

export default SaathiCertificationDetails;
